import React from 'react';
import { GatsbyImage, getImage } from "gatsby-plugin-image";

import RichText from '../../lib/contentful/rich-text';
import * as styles from './index.module.scss';

const HeroBlock = ({
  backgroundColor = '#fff',
  textColour = '#000',
  title,
  defaultTitle = "Hamworthy Heating",
  paragraphIsJsx,
  paragraph,
  spaceBottom,
  image,
  pageType,
  headerStyle,
  splitTitle
}) => {

  return (
    <div
      className={styles.hero + " " + `${headerStyle === "Shorter" ? styles.shortHero : ""}`  + " " + (spaceBottom ? styles.marginBottom : '')}
      style={{ backgroundColor: backgroundColor, color: textColour }}
    >
      <div
        className={`
          ${styles.contentWrapper} 
        `}
      >
        <div className={styles.title}>
            <h1 className={styles.heading}>
              { title ? title : defaultTitle }
              {
                splitTitle &&
                <small>{splitTitle}</small>
              }
            </h1>
        </div>
        <div className={styles.content}>
          {paragraphIsJsx ? paragraph : (paragraph && typeof paragraph === 'object') ?
            RichText(paragraph)
            : (paragraph && typeof paragraph === 'string') ? <p>{paragraph}</p> : null}
        </div>
      </div>
      { !/Article|Blog/g.test(pageType) ?
          image &&
          image?.gatsbyImageData ?
            <GatsbyImage 
              alt={image?.title ? image?.title : ""}
              className={styles.image} 
              image={getImage(image)} 
            />
          :
            <img src={image} alt="" className={styles.image}  />
        :
          null
      }
      <div 
        className={styles.overlay} 
        style={{"backgroundColor":backgroundColor}}
      ></div>
    </div>
  );
}

export default HeroBlock;